(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fs-collection-grid')) {
    customElements.define('fs-collection-grid', class extends HTMLElement {
      connectedCallback() {
        this.syncBar = () => {
          if (this.barFrame) return;
          this.barFrame = requestAnimationFrame(() => {
            this.barFrame = 0;
            const bounds = this.getBoundingClientRect();
            this.toggleAttribute('data-bar-visible', bounds.top < innerHeight - 48 && bounds.bottom > 48);
          });
        };
        document.addEventListener('scroll', this.syncBar, { capture: true, passive: true });
        window.addEventListener('resize', this.syncBar);
        this.sizeObserver = new ResizeObserver(this.syncBar);
        this.sizeObserver.observe(this);
        this.syncBar();
        // Price slider: a handle moves its input and the dark range; typing moves the handle.
        this.addEventListener('input', (event) => {
          const price = event.target.closest('[data-fs-price]');
          if (price) this.syncPrice(price, event.target);
        });
        // Computer panel and Sort sheet: a choice applies at once.
        this.addEventListener('change', (event) => {
          const form = event.target.closest('[data-fs-instant]');
          if (form) this.update(this.urlFromForm(form));
        });
        // Phone Filters sheet: choices wait for APPLY.
        this.addEventListener('submit', (event) => {
          const form = event.target.closest('[data-fs-filters]');
          if (!form) return;
          event.preventDefault();
          this.update(this.urlFromForm(form));
        });
        this.addEventListener('click', (event) => {
          const reset = event.target.closest('[data-fs-reset]');
          if (reset) {
            event.preventDefault();
            this.update(new URL(reset.href, location.origin));
            return;
          }
          const open = event.target.closest('[data-fs-open]');
          if (open) {
            const sheet = this.querySelector(`[data-fs-sheet="${open.dataset.fsOpen}"]`);
            if (sheet && !sheet.open) sheet.showModal();
            return;
          }
          if (event.target.closest('[data-fs-close]')) {
            event.target.closest('dialog').close();
            return;
          }
          // a click on the dimmed backdrop lands on the dialog itself
          if (event.target.matches('dialog.fs-sheet')) event.target.close();
        });
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.syncBar, true);
        window.removeEventListener('resize', this.syncBar);
        this.sizeObserver?.disconnect();
        cancelAnimationFrame(this.barFrame);
      }

      urlFromForm(form) {
        const url = new URL(form.action, location.origin);
        // an empty price input means no limit, so it adds nothing to the address
        for (const [key, value] of new FormData(form)) if (value !== '') url.searchParams.append(key, value);
        return url;
      }

      syncPrice(price, moved) {
        const handles = price.querySelectorAll('[data-fs-price-handle]');
        const inputs = price.querySelectorAll('[data-fs-price-input]');
        const max = Number(handles[1].max);
        if (moved.matches('[data-fs-price-handle]')) {
          // a handle never passes the other one
          if (Number(handles[0].value) > Number(handles[1].value)) {
            moved.value = moved === handles[0] ? handles[1].value : handles[0].value;
          }
          // a handle at its own end means no limit on that side
          inputs[0].value = Number(handles[0].value) > 0 ? handles[0].value : '';
          inputs[1].value = Number(handles[1].value) < max ? handles[1].value : '';
        } else {
          const i = moved === inputs[0] ? 0 : 1;
          const typed = moved.value === '' ? (i ? max : 0) : Math.min(Math.max(Number(moved.value), 0), max);
          handles[i].value = typed;
        }
        price.style.setProperty('--fs-lo', (handles[0].value / max) * 100 + '%');
        price.style.setProperty('--fs-hi', (handles[1].value / max) * 100 + '%');
      }

      async update(url) {
        this.setAttribute('aria-busy', 'true');
        const fetchUrl = new URL(url);
        fetchUrl.searchParams.set('section_id', this.dataset.sectionId);
        try {
          const response = await fetch(fetchUrl);
          if (!response.ok) throw new Error(response.status);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fresh = html.querySelector('fs-collection-grid');
          if (!fresh) throw new Error('no grid in response');
          const openGroups = [...this.querySelectorAll('.fs-grid__panel .fs-filters__group')].map((group) => group.open);
          this.querySelectorAll('dialog[open]').forEach((sheet) => sheet.close());
          this.innerHTML = fresh.innerHTML;
          this.querySelectorAll('.fs-grid__panel .fs-filters__group').forEach((group, i) => {
            if (openGroups[i] === false) group.open = false;
          });
          history.replaceState({}, '', url.pathname + url.search);
          const status = this.previousElementSibling;
          const count = this.querySelectorAll('.fs-grid__item').length;
          if (status && status.matches('[data-fs-status]')) {
            status.textContent = count === 1 ? '1 product' : count + ' products';
          }
        } catch (error) {
          location.assign(url);
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fs-faq')) {
    customElements.define('fs-faq', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.nav = this.querySelector('.fs-faq__nav');
        this.wrapper = this.closest('.page-wrapper');
        this.tabs = [...this.querySelectorAll('.fs-faq__tab')];
        this.groups = [...this.querySelectorAll('.fs-faq__group')];
        this.animations = new Map();
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.addEventListener('click', event => {
          const tab = event.target.closest('.fs-faq__tab');
          if (tab) {
            event.preventDefault();
            const target = this.groups.find(group => '#' + group.id === tab.hash);
            if (!target) return;
            this.updateMetrics();
            this.scrollTarget = target;
            this.setActive(target.id);
            const currentTop = this.scroller === window ? scrollY : this.scroller.scrollTop;
            const originTop = this.scroller === window ? 0 : this.scroller.getBoundingClientRect().top;
            const top = target.getBoundingClientRect().top - originTop + currentTop - this.offset - this.nav.offsetHeight;
            this.scroller.scrollTo({top: Math.max(0, top), behavior: this.reduced.matches ? 'instant' : 'smooth'});
            history.replaceState(null, '', location.pathname + location.search + tab.hash);
            return;
          }
          const summary = event.target.closest('.fs-faq__question');
          if (!summary) return;
          event.preventDefault();
          const item = summary.parentElement;
          const opening = item.dataset.expanded ? item.dataset.expanded !== 'true' : !item.open;
          if (opening && this.dataset.single === 'true') {
            item.closest('.fs-faq__group').querySelectorAll('.fs-faq__item[open]').forEach(other => {
              if (other !== item) this.expand(other, false);
            });
          }
          this.expand(item, opening);
        }, {signal});
        const onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.syncActive(); });
        };
        window.addEventListener('scroll', onScroll, {passive: true, signal});
        this.wrapper?.addEventListener('scroll', onScroll, {passive: true, signal});
        const releaseTarget = () => { this.scrollTarget = null; };
        window.addEventListener('wheel', releaseTarget, {passive: true, signal});
        window.addEventListener('touchstart', releaseTarget, {passive: true, signal});
        window.addEventListener('keydown', event => {
          if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End'].includes(event.key)) releaseTarget();
        }, {signal});
        window.addEventListener('resize', () => { this.updateMetrics(); onScroll(); }, {passive: true, signal});
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const group = event.target.closest('.fs-faq__group');
          const item = event.target.closest('.fs-faq__item');
          if (item) this.expand(item, true);
          if (group) { this.setActive(group.id); group.scrollIntoView({behavior: 'smooth', block: 'start'}); }
        }, {signal});
        this.observer = new ResizeObserver(() => { this.updateMetrics(); onScroll(); });
        this.observer.observe(this.nav);
        const header = document.querySelector('[data-fs-header]');
        if (header) this.observer.observe(header);
        this.updateMetrics();
        this.syncActive();
        if (location.hash) requestAnimationFrame(() => {
          const target = this.groups.find(group => '#' + group.id === location.hash);
          if (target) target.scrollIntoView({block: 'start'});
        });
      }
      updateMetrics() {
        const wrapperStyle = this.wrapper && getComputedStyle(this.wrapper);
        const wrapperScrolls = wrapperStyle && /auto|scroll/.test(wrapperStyle.overflowY) && this.wrapper.scrollHeight > this.wrapper.clientHeight + 1;
        this.scroller = wrapperScrolls ? this.wrapper : window;
        const headerSection = document.querySelector('.fs-header-section');
        const header = headerSection?.querySelector('[data-fs-header]') || headerSection;
        this.offset = header && headerSection && ['sticky', 'fixed'].includes(getComputedStyle(headerSection).position) ? header.getBoundingClientRect().height : 0;
        this.style.setProperty('--faq-top', this.offset + 'px');
        this.style.setProperty('--faq-nav-height', this.nav.offsetHeight + 'px');
      }
      setActive(id) {
        this.tabs.forEach(tab => {
          const active = tab.hash === '#' + id;
          tab.classList.toggle('is-active', active);
          if (active) tab.setAttribute('aria-current', 'location');
          else tab.removeAttribute('aria-current');
        });
        const tab = this.tabs.find(tab => tab.hash === '#' + id);
        const row = this.querySelector('.fs-faq__tabs');
        if (tab && row && row.scrollWidth > row.clientWidth) {
          const rect = tab.getBoundingClientRect(), bounds = row.getBoundingClientRect();
          if (rect.left < bounds.left || rect.right > bounds.right) row.scrollTo({left: tab.offsetLeft - row.offsetLeft - (row.clientWidth - tab.offsetWidth) / 2, behavior: this.reduced.matches ? 'instant' : 'smooth'});
        }
      }
      syncActive() {
        if (!this.groups.length) return;
        const originTop = this.scroller === window ? 0 : this.scroller.getBoundingClientRect().top;
        const targetLine = originTop + this.offset + this.nav.offsetHeight;
        if (this.scrollTarget) {
          const top = this.scrollTarget.getBoundingClientRect().top;
          this.setActive(this.scrollTarget.id);
          if (Math.abs(top - targetLine) <= 2) this.scrollTarget = null;
          return;
        }
        const line = targetLine + 2;
        let current = this.groups[0];
        for (const group of this.groups) if (group.getBoundingClientRect().top <= line) current = group;
        this.setActive(current.id);
      }
      expand(item, open) {
        const start = item.getBoundingClientRect().height;
        this.animations.get(item)?.cancel();
        item.dataset.expanded = String(open);
        item.open = open;
        const end = item.getBoundingClientRect().height;
        if (this.reduced.matches || !item.animate) { item.style.overflow = ''; return; }
        if (!open) item.open = true;
        item.style.overflow = 'hidden';
        const animation = item.animate([{height: start + 'px'}, {height: end + 'px'}], {duration: 300, easing: 'cubic-bezier(.22,1,.36,1)'});
        this.animations.set(item, animation);
        animation.onfinish = () => {
          item.open = open;
          item.style.overflow = '';
          this.animations.delete(item);
          this.syncActive();
        };
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.animations?.forEach(animation => animation.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-shoppable-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fs-shoppable-video')) {
    /* Plays each video only while it is on screen, and keeps sound on one video at a time
       (Figma annotation, Mute / Unmute Toggle). */
    class FsShoppableVideo extends HTMLElement {
      connectedCallback() {
        this.videos = [...this.querySelectorAll('video')];
        this.onClick = (event) => {
          const button = event.target.closest('.fs-video__mute');
          if (button) this.toggleSound(button);
        };
        this.addEventListener('click', this.onClick);
        if (!('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            const video = entry.target;
            if (entry.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          }
        }, { threshold: 0.25 });
        this.videos.forEach((video) => this.observer.observe(video));
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.observer?.disconnect();
      }

      toggleSound(button) {
        const video = button.closest('.fs-video__media')?.querySelector('video');
        if (!video) return;
        const unmute = video.muted;
        for (const other of this.querySelectorAll('.fs-video__mute')) {
          const otherVideo = other.closest('.fs-video__media')?.querySelector('video');
          if (otherVideo) otherVideo.muted = true;
          other.setAttribute('aria-pressed', 'false');
          other.setAttribute('aria-label', 'Unmute video');
        }
        if (unmute) {
          video.muted = false;
          video.play().catch(() => {});
          button.setAttribute('aria-pressed', 'true');
          button.setAttribute('aria-label', 'Mute video');
        }
      }
    }
    customElements.define('fs-shoppable-video', FsShoppableVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
